import { Reducer } from 'redux'
import _ from 'lodash'
import { Flow, FlowValidationResult, FlowValidationParameters } from './types'
import * as actions from './actions'

export type FlowState = Readonly<{
  flows: Record<string, Flow>
  isValidating: boolean
  isSaving: boolean
  validationResult: FlowValidationResult | null
  selectedFlow: FlowValidationParameters | null
}>

export const initState: FlowState = {
  flows: {},
  isValidating: false,
  isSaving: false,
  validationResult: null,
  selectedFlow: null
}

export const flowReducer: Reducer<FlowState, actions.FlowActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_FLOWS_SUCCESS:
      return {
        ...state,
        flows: { ..._.keyBy(action.payload, 'id') }
      }
    case actions.FETCH_FLOW_INFO:
      return {
        ...state,
        isLoading: true
      }
    case actions.FETCH_FLOW_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedFlow: action.payload.flow
      }
    case actions.UPDATE_NEW_FLOW:
      return {
        ...state,
        selectedFlow: action.payload.flow
      }
    case actions.RESET_NEW_FLOW:
      return {
        ...state,
        selectedFlow: null
      }
    case actions.START_FLOW_VALIDATION:
      return {
        ...state,
        isValidating: true
      }
    case actions.UPDATE_FLOW_VALIDATION:
      return {
        ...state,
        validationResult: action.payload,
        isValidating: false
      }
    case actions.START_SAVING_FLOW:
      return {
        ...state,
        isSaving: true
      }
    case actions.SAVING_FLOW_SUCCESS:
      return {
        ...state,
        isSaving: false
      }
    default:
      return state
  }
}
